import Event from '../core/Event';
import UserAuthenticationSucceed from './events/UserAuthenticationSucceed';
import UserNotAuthorized from './events/UserNotAuthorized';
import UserAuthenticationFailed from './events/UserAuthenticationFailed';
import UserAuthenticationRequested from './events/UserAuthenticationRequested';
import User from './State';
import initialState from './initialState';
import UserDetailsGetSucceed from './events/UserDetailsGetSucceed';
import UserLogoutCompleted from './events/UserLogoutCompleted';

export default (state: User = initialState, anyEvent: Event): User => {
    switch (anyEvent.type) {
        case UserAuthenticationRequested.type: {
            return {
                ...state,
                errorMessage: ''
            };
        }
        case UserDetailsGetSucceed.type: {
            const event: UserDetailsGetSucceed = anyEvent as UserDetailsGetSucceed;
            return {
                ...state,
                ...event.customer,
                shippingMethod: ''
            };
        }
        case UserAuthenticationSucceed.type: {
            const event: UserAuthenticationSucceed = anyEvent as UserAuthenticationSucceed;
            return {
                ...state,
                role: event.sessionDetails.role,
                customerId: event.sessionDetails.customerId
            };
        }
        case UserLogoutCompleted.type: {
            return {
                ...initialState
            };
        }
        case UserNotAuthorized.type: {
            return {
                ...state,
                initialLocation: (anyEvent as UserNotAuthorized).initialLocation
            };
        }
        case UserAuthenticationFailed.type: {
            return {
                ...state,
                errorMessage: (anyEvent as UserAuthenticationFailed).message
            };
        }
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/user/reducer.ts